<template>
  <div class="grid-container full">
    <div class="grid-x questionCont">
      <div :tabindex="tabIndex" @keypress="toogleSlideDown" class="small-11 cell text-left no-padding">
        <p class="question" @click="toogleSlideDown" v-html="question"></p>
        <p v-if="paneOpen" @click="slideUp" class="answer" v-html="answer"></p>
      </div>
      <div class="small-1 cell text-centre vertical-align-middle no-padding">
        <span class="openClose" v-if="paneOpen" @click="slideUp" >-</span>
        <span class="openClose" v-else  @click="slideDown">+</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareLegalFaqQuestionComponent',
  props: {
    question: {
      type: String,
      required: false,
      default: 'xxxxx',
    },
    answer: {
      type: String,
      required: false,
      default: 'yyyyy',
    },
    tabIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      paneOpen: false,
    };
  },
  methods: {
    slideDown() {
      this.paneOpen = true;
    },
    slideUp() {
      this.paneOpen = false;
    },
    toogleSlideDown() {
      if (this.paneOpen === true) {
        this.slideUp();
      } else {
        this.slideDown();
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .question {
    cursor: pointer;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    margin: 7px 0 0 0;
  }

  .answer {
    cursor: pointer;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    margin: 10px 0 0 0;
  }

  .openClose {
    font-size: 26px;
    padding: 0 10px;
    cursor: pointer;
  }

  @media only screen and (max-width: 640px)  {

    .question {
      font-size: 18px;
      line-height: 1.78;
    }

    .answer {
      font-size: 14px;
      line-height: 1.71;
    }

    .questionCont {
      border-bottom: 1px solid #c4cace;
      padding: 16px 0 16px 0;
    }

  }

  @media only screen and (min-width: 641px)  {

    .question {
      font-size: 24px;
      line-height: 1;
    }

    .answer {
      font-size: 18px;
      line-height: 1.78;
    }

    .questionCont {
      border-bottom: 1px solid #c4cace;
      padding: 32px 0 32px 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalFaqQuestionComponent.vue